export default __webpack_public_path__ + "static/media/plane.7b836965.less";